import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function FileIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <>
        <path d="M16 16a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zM13 12a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2z" />
        <path d="M14.343 1c1.326 0 2.598.527 3.536 1.465l2.656 2.656.171.18A5 5 0 0 1 22 8.657V18a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V6a5 5 0 0 1 5-5zM7 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V9h-2a4 4 0 0 1-4-4V3zm9 2a2 2 0 0 0 2 2h1.498a3 3 0 0 0-.178-.244l-.199-.22-2.656-2.657a3 3 0 0 0-.465-.38z" />
      </>
    </Icon>
  );
}

FileIcon.displayName = 'FileIcon';
